import firebase from "../Config/firebase"

import {isEmpty, isLoaded} from "react-redux-firebase";


const db = firebase.firestore()

export const uiConfig = {
    signInFlow: "redirect",
    signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID
    ],
    callbacks: {
        signInSuccess: () => {
            firebase.analytics().logEvent('login');
            this.props.history.push({pathname: "/login"})
        }
    }
}

export function isAuth(auth) {
    return isLoaded(auth) && !isEmpty(auth)
}


export function logout(firebase) {
    firebase.auth().signOut()
        .then(function () {
            // Sign-out successful.
        })
        .catch(function (error) {
            // An error happened
        });
}

export function isUndefined(parm) {
    return typeof parm === 'undefined' || parm === '0' || parm === 0 || parm === false
}

export function getFirebaseCustomClaim(auth) {
    return new Promise((resolve, reject) => {
        if (isAuth(auth)) {
            firebase.auth().currentUser.getIdTokenResult()
                .then(idTokenResult => {
                    if (idTokenResult.claims.hasOwnProperty("userName") && Array.isArray(idTokenResult.claims.userName)) {
                        let newArr = []
                        idTokenResult.claims.userName.map(e => {
                            newArr.push({
                                value: e,
                                label: e
                            })
                        })
                        resolve({
                            success: true,
                            userName: newArr
                        })
                    } else {
                        resolve({
                            success: true,
                            userName: [{value: "å¿å", label: "å¿å"}]
                        })
                    }
                })
        }
    })

}

export function isHost() {
    return window.location.host === 'mewesearcher.com' ||   window.location.host === 'mewesearcher.web.app'
}